import { ImArrowUpRight2 } from "react-icons/im";
import { Accordion } from "../../../components/elements/forms/Accordion";

const FaqJobSeekers = () => {
  return (
    <div className="accordion font-abel mb-20">
      <Accordion title="1. How do I submit my CV?">
        Upload your CV directly through our platform when applying for a role.
        Please use <b className="font-[900]">PDF or Word format</b> for the best
        results. Once submitted, you'll receive an{" "}
        <b className="font-[900]">immediate confirmation</b>, and a{" "}
        <b className="font-[900]">pre-test and assessment</b> will be sent to
        your inbox. Your responses are expected{" "}
        <b className="font-[900]">within 24–72 hours</b> to proceed to the next
        stage of the recruitment process.
      </Accordion>
      <Accordion title="2. What happens after I apply?">
        Your profile is reviewed through our AI Recruiter. If there's a match,
        our team will contact you for the next steps, including role-specific
        interviews or assessments where applicable.
      </Accordion>
      <Accordion title="3. How long does the process take?">
        Timelines vary by role, but you'll receive updates at each stage of the
        process.
      </Accordion>
      <Accordion title="4. Do I have to pay any fees?">
        Applying for jobs is completely free. However, if you wish to receive
        your interview results and personalized feedback, you may opt in for
        this optional service for a minimal fee.
      </Accordion>
      <Accordion title="5. Can I apply for more than one job?">
        Yes, you may apply for multiple roles that align with your skills and
        experience by logging into your{" "}
        <a
          href="https://candidate.25thandstaffing.com/login"
          className="text-primary"
          target="_blank"
          rel="noreferrer"
        >
          Candidate Portal
        </a>{" "}
        using the automated password that was created and sent to your inbox at
        registration. If you're unable to locate the password, please click on
        "Forgot Password" to reset and regain access to your account.
      </Accordion>
      <Accordion title="6. How can I find open positions?">
        <span className="flex items-center">
          You can view and apply for open roles on our{" "}
          <a
            href="https://25thandstaffing.com/marketplace"
            className="text-primary flex items-center pl-1"
            target="_blank"
            rel="noreferrer"
          >
            Job Marketplace
            <span className="mx-1">
              <ImArrowUpRight2 size={15} />
            </span>
          </a>
          . We're also integrating this feature into our AI Recruiter for a
          smoother experience.
        </span>
      </Accordion>
      <Accordion title="7. What if there are no suitable openings right now?">
        You can join our{" "}
        <a
          href="https://25thandstaffing.com/marketplace"
          className="text-primary"
          target="_blank"
          rel="noreferrer"
        >
          Talent Pool
        </a>{" "}
        to be considered for future opportunities. You'll be redirected to our
        Job Marketplace, where you can complete your interview and assessment
        (if applicable) within a <b className="font-[900]">24–72-hour window</b>{" "}
        after uploading your resume.
      </Accordion>
      <Accordion title="8. How can I update my information?">
        <span className="">
          You can update your information at any time by logging into your{" "}
          <a
            href="https://25thandstaffing.com/marketplace"
            className="text-primary "
            target="_blank"
            rel="noreferrer"
          >
            Candidate Portal
            {/* <span className="px-1">
              <ImArrowUpRight2 size={15} />
            </span> */}
          </a>
          , clicking <b className="font-[900]">"View Profile,"</b> and then
          selecting the <b className="font-[900]">"Edit Profile"</b> icon to
          make and save your changes.
        </span>
      </Accordion>
      <Accordion title="9. How is my data handled?">
        All applicant information is processed with strict confidentiality and
        in compliance with global data protection standards.
      </Accordion>
      <Accordion title="10. Who do I contact for help?">
        <span className="flex">
          Email our support team at{" "}
          <a
            href="mailto:support@25thmail.com"
            className="text-primary flex items-center px-1"
          >
            support@25thmail.com
            <span className="ml-1">
              <ImArrowUpRight2 size={15} />
            </span>
          </a>{" "}
          for application or account-related inquiries.
        </span>
      </Accordion>
    </div>
  );
};

export default FaqJobSeekers;
